// export default App;
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Base from "./Component/User/Base";
import Home from "./Component/User/Home";
import About from "./Component/User/About";
import Service from "./Component/User/Service";
import Product from "./Component/User/Product";
import Team from "./Component/User/Team";
import Blog from "./Component/User/Blog";
import ReadBlog from "./Component/User/ReadBlog";
import Carrer from "./Component/User/Carrer";
import Contact from "./Component/User/Contact";
import AdminLogin from "./Component/User/AdminLogin";

// Admin Site
import AdminBase from "./Component/Admin/AdminBase";
import AdminDashboard from "./Component/Admin/AdminDashboard";
import AdminService from "./Component/Admin/AdminService";
import AdminProduct from "./Component/Admin/AdminProduct";
import AdminTeam from "./Component/Admin/AdminTeam";
import AdminWork from "./Component/Admin/AdminWork";
import AdminClient from "./Component/Admin/AdminClient";
import AdminBlog from "./Component/Admin/AdminBlog";
import GroupImage from "./Component/Admin/GroupImage";
import AdminCarrer from "./Component/Admin/AdminCarrer";
import Application from "./Component/Admin/Application";
import AdminContacts from "./Component/Admin/AdminContacts";
import Admin from "./Component/Admin/Admin";
import ProtectedAdminRoute from "./Component/Admin/ProtectedAdminRoute";
import AdminLogout from "./Component/Admin/AdminLogout";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* User Routes */}
        <Route path="/" element={<Base />}>
          <Route index element={<Home />} />
          <Route path="about" element={<About />} />
          <Route path="service" element={<Service />} />
          <Route path="product" element={<Product />} />
          <Route path="team" element={<Team />} />
          <Route path="blog" element={<Blog />} />
          <Route path="/readBlog/:id" element={<ReadBlog />} />
          <Route path="carrer" element={<Carrer />} />
          <Route path="contact" element={<Contact />} />
          <Route path="adminLogin" element={<AdminLogin />} />
        </Route>

        {/* Admin Routes */}
        <Route 
          path="/admin" 
          element={
            <ProtectedAdminRoute>
              <AdminBase />
            </ProtectedAdminRoute>
          }
        >
            <Route path="dashboard" element={<AdminDashboard />} />
            <Route path="service" element={<AdminService />} />
            <Route path="product" element={<AdminProduct />} />
            <Route path="team" element={<AdminTeam />} />
            <Route path="work" element={<AdminWork />} />
            <Route path="clientReview" element={<AdminClient />} />
            <Route path="carrer" element={<AdminCarrer />} />
            <Route path="blogs" element={<AdminBlog />} />
            <Route path="groupImg" element={<GroupImage />} />
            <Route path="application" element={<Application />} />
            <Route path="userContacts" element={<AdminContacts />} />
            <Route path="adminAccess" element={<Admin />} />
            <Route path="logout" element={<AdminLogout />} />
        </Route>
        {/* Add more admin routes here */}
      </Routes>
    </BrowserRouter>
  );
}

export default App;
